import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcConfirmCloseDialogComponent = /** @class */ (function () {
    function FcConfirmCloseDialogComponent(fuseTranslationLoaderService, dialogRef, data, translate) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.translate = translate;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcConfirmCloseDialogComponent.prototype.ngOnInit = function () {
        this.setDefaultValues();
    };
    FcConfirmCloseDialogComponent.prototype.setDefaultValues = function () {
        if (!this.data.title) {
            this.data.title = this.translate.instant('FC_CONFIRM_DIALOG.TITLE');
        }
        if (!this.data.description) {
            this.data.description = this.translate.instant('FC_CONFIRM_DIALOG.DESCRIPTION');
        }
        if (!this.data.highlightButton) {
            this.data.highlightButton = this.translate.instant('FC_CONFIRM_DIALOG.HIGHLIGHT_BUTTON');
        }
        if (!this.data.unHighlightedButton) {
            this.data.unHighlightedButton = this.translate.instant('FC_CONFIRM_DIALOG.UN_HIGHLIGHTED_BUTTON');
        }
    };
    FcConfirmCloseDialogComponent.prototype.highlightButtonFunction = function () {
        if (this.data.highlightButtonFunction) {
            this.data.highlightButtonFunction();
        }
        this.dialogRef.close();
    };
    FcConfirmCloseDialogComponent.prototype.unHighlightedButtonFunction = function () {
        if (this.data.unHighlightedButtonFunction) {
            this.data.unHighlightedButtonFunction();
        }
        this.dialogRef.close();
    };
    return FcConfirmCloseDialogComponent;
}());
export { FcConfirmCloseDialogComponent };
